<div class="sub-heading">Enter your email and password to login.</div>
<form class="login-form" [formGroup]="loginForm" (ngSubmit)="loginSumbit()">
  <label class="f-label">Email</label>
  <mat-form-field class="input-field" appearance="outline">
    <input type="email" matInput placeholder="your@email.com" formControlName="email" required>
    <mat-icon matSuffix>person</mat-icon>
  </mat-form-field>
  <label class="f-label">Password</label>
  <mat-form-field class="input-field" appearance="outline">
    <input [type]="showPassword ? 'text': 'password'" matInput placeholder="Enter your password"
      formControlName="password" required>
    <mat-icon matSuffix (click)="$event.stopPropagation(); showPassword = !showPassword">{{showPassword ?
      'visibility' : 'visibility_off'}} </mat-icon>
  </mat-form-field>
  <div class="forgot-pwd-sec">
    <mat-checkbox class="example-margin" color="primary" formControlName="rememberMe">Remember me</mat-checkbox>
    <a mat-button (click)="forgotPassword()" href="javascript:void(0)" class="forgot-password">Forgot Password</a>
  </div>
  <div class="submit-section">
    <button mat-flat-button color="primary" type="submit" [disabled]="!loginForm.valid"
      class="login-btn-txt">Login</button>
    <a mat-button href="javascript:void(0)" class="register-btn-txt" (click)="gotoRegister()">Go to signup</a>
  </div>
</form>